import React, { useState, useEffect } from 'react';
import Header from '../Header'; // Header ফাইলটি ইমপোর্ট করা হলো
import Footer from '../Footer'; // 🚨 NEW: Footer ইমপোর্ট করা হলো 🚨

function EMICalculator({ view, setView, searchTerm, setSearchTerm, cityFilter, setCityFilter, setActiveTab }) {
  // State for inputs
  const [principal, setPrincipal] = useState(1500000);
  const [tenure, setTenure] = useState(84);
  const [interestRate, setInterestRate] = useState(15);

  // State for results
  const [emi, setEmi] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  // EMI Calculation Logic
  useEffect(() => {
    const p = principal;
    const r = interestRate / 12 / 100; // Monthly interest rate
    const n = tenure; // Tenure in months

    if (p > 0 && r > 0 && n > 0) {
      // EMI Formula: P * r * (1 + r)^n / ((1 + r)^n - 1)
      const calculatedEmi = (p * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
      const totalPayable = calculatedEmi * n;
      const totalInt = totalPayable - p;

      setEmi(Math.round(calculatedEmi));
      setTotalAmount(Math.round(totalPayable));
      setTotalInterest(Math.round(totalInt));
    } else {
      setEmi(0);
      setTotalAmount(p);
      setTotalInterest(0);
    }
  }, [principal, tenure, interestRate]);

  // Chart Percentage Logic
  const interestPercent = totalAmount > 0 ? (totalInterest / totalAmount) * 100 : 0;
  const principalPercent = totalAmount > 0 ? (principal / totalAmount) * 100 : 100;

  // Slider Track Fill Logic
  const getSliderStyle = (val, min, max) => {
    const percentage = ((val - min) / (max - min)) * 100;
    return {
      background: `linear-gradient(to right, #4646fa ${percentage}%, #f1f1f5 ${percentage}%)`
    };
  };

  const rangeInputStyle = {
    WebkitAppearance: 'none',
    width: '100%',
    height: '6px',
    borderRadius: '5px',
    outline: 'none',
    marginTop: '15px',
    marginBottom: '8px',
    cursor: 'pointer'
  };

  return (
    // 🚨 পেজের কন্টেন্ট এবং ফুটার ঠিক রাখতে display: flex ও flexDirection: column করা হয়েছে 🚨
    <div style={{ backgroundColor: '#f9fafb', minHeight: '100vh', fontFamily: 'sans-serif', display: 'flex', flexDirection: 'column' }}>
      {/* 🚨 HEADER 🚨 */}
      <Header view={view} setView={setView} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />

      {/* 🚨 ফুটারকে নিচে ঠেলে দেওয়ার জন্য flex: 1 অ্যাড করা হলো 🚨 */}
      <main style={{ maxWidth: '1100px', margin: '60px auto', padding: '0 20px', flex: 1, width: '100%' }}>
        
        {/* Page Title */}
        <h1 style={{ textAlign: 'center', fontSize: '32px', fontWeight: 'bold', color: '#1a1a1a', marginBottom: '40px' }}>
          Used car loan <span style={{ color: '#6c4df6' }}>EMI Calculator</span>
        </h1>

        {/* Main Calculator Card */}
        <div style={{ backgroundColor: '#fff', borderRadius: '20px', border: '1px solid #eee', display: 'flex', flexWrap: 'wrap', overflow: 'hidden', boxShadow: '0 10px 40px rgba(0,0,0,0.03)' }}>
          
          {/* 🚨 LEFT SIDE: CONTROLS 🚨 */}
          <div style={{ flex: '1 1 500px', padding: '50px 40px' }}>
            
            {/* Loan Amount */}
            <div style={{ marginBottom: '40px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <label style={{ fontWeight: 'bold', fontSize: '14px', color: '#1a1a1a' }}>Loan amount</label>
                <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#fff', border: '1px solid #eee', padding: '10px 15px', borderRadius: '8px', width: '150px' }}>
                  <span style={{ color: '#888', fontWeight: 'bold', marginRight: '5px' }}>₹</span>
                  <input type="text" value={principal.toLocaleString('en-IN')} readOnly style={{ border: 'none', outline: 'none', fontWeight: 'bold', width: '100%', color: '#444' }} />
                </div>
              </div>
              <input type="range" min="50000" max="5000000" step="10000" value={principal} onChange={(e) => setPrincipal(Number(e.target.value))} style={{ ...rangeInputStyle, ...getSliderStyle(principal, 50000, 5000000) }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#aaa', fontWeight: 'bold' }}>
                <span>₹50,000</span>
                <span>₹50,00,000</span>
              </div>
            </div>

            <div style={{ borderBottom: '1px dashed #eee', marginBottom: '40px' }}></div>

            {/* Tenure */}
            <div style={{ marginBottom: '40px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <label style={{ fontWeight: 'bold', fontSize: '14px', color: '#1a1a1a' }}>Tenure</label>
                <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#fff', border: '1px solid #eee', padding: '10px 15px', borderRadius: '8px', width: '150px' }}>
                  <input type="text" value={`${tenure} months`} readOnly style={{ border: 'none', outline: 'none', fontWeight: 'bold', width: '100%', color: '#444' }} />
                </div>
              </div>
              <input type="range" min="12" max="84" step="1" value={tenure} onChange={(e) => setTenure(Number(e.target.value))} style={{ ...rangeInputStyle, ...getSliderStyle(tenure, 12, 84) }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#aaa', fontWeight: 'bold' }}>
                <span>12 months</span>
                <span>84 months</span>
              </div>
            </div>

            <div style={{ borderBottom: '1px dashed #eee', marginBottom: '40px' }}></div>

            {/* Interest Rate */}
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <label style={{ fontWeight: 'bold', fontSize: '14px', color: '#1a1a1a' }}>Interest rate</label>
                <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#fff', border: '1px solid #eee', padding: '10px 15px', borderRadius: '8px', width: '150px' }}>
                  <input type="text" value={`${interestRate}%`} readOnly style={{ border: 'none', outline: 'none', fontWeight: 'bold', width: '100%', color: '#444' }} />
                </div>
              </div>
              <input type="range" min="10" max="25" step="0.1" value={interestRate} onChange={(e) => setInterestRate(Number(e.target.value))} style={{ ...rangeInputStyle, ...getSliderStyle(interestRate, 10, 25) }} />
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#aaa', fontWeight: 'bold' }}>
                <span>10%</span>
                <span>25%</span>
              </div>
            </div>

          </div>

          {/* 🚨 RIGHT SIDE: VISUALS & RESULTS 🚨 */}
          <div style={{ flex: '1 1 400px', backgroundColor: '#f6f7fc', padding: '50px 40px', display: 'flex', flexDirection: 'column' }}>
            
            {/* Doughnut Chart */}
            <div style={{ alignSelf: 'center', position: 'relative', width: '220px', height: '220px', borderRadius: '50%', background: `conic-gradient(#5b5bfe 0% ${interestPercent}%, #e0e0fe ${interestPercent}% 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '40px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' }}>
              {/* Inner Circle (Hole) */}
              <div style={{ width: '150px', height: '150px', backgroundColor: '#fff', borderRadius: '50%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', boxShadow: 'inset 0 2px 5px rgba(0,0,0,0.05)' }}>
                <span style={{ fontSize: '11px', color: '#666', fontWeight: 'bold', marginBottom: '5px' }}>Your monthly EMI will be</span>
                <span style={{ fontSize: '28px', fontWeight: '900', color: '#1a1a1a' }}>₹{emi.toLocaleString('en-IN')}</span>
              </div>
            </div>

            {/* Results Details */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: 'auto' }}>
              
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ width: '10px', height: '10px', borderRadius: '3px', backgroundColor: '#e0e0fe' }}></div>
                  <span style={{ fontSize: '14px', color: '#666', fontWeight: '600' }}>Principal amount</span>
                </div>
                <span style={{ fontSize: '15px', fontWeight: 'bold', color: '#1a1a1a' }}>₹{principal.toLocaleString('en-IN')}</span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ width: '10px', height: '10px', borderRadius: '3px', backgroundColor: '#5b5bfe' }}></div>
                  <span style={{ fontSize: '14px', color: '#666', fontWeight: '600' }}>Interest @{interestRate}% p.a.</span>
                </div>
                <span style={{ fontSize: '15px', fontWeight: 'bold', color: '#1a1a1a' }}>+ ₹{totalInterest.toLocaleString('en-IN')}</span>
              </div>

              <div style={{ borderBottom: '1px solid #ddd', margin: '10px 0' }}></div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '16px', color: '#1a1a1a', fontWeight: '900' }}>Total amount</span>
                <span style={{ fontSize: '18px', fontWeight: '900', color: '#1a1a1a' }}>₹{totalAmount.toLocaleString('en-IN')}</span>
              </div>

            </div>
          </div>

        </div>
      </main>

      {/* 🚨 NEW: Footer Section Added Here 🚨 */}
      <Footer setView={setView} />

      {/* Internal Custom CSS for Slider Thumb (Optional but makes it look exactly like screenshot) */}
      <style>{`
        input[type=range]::-webkit-slider-thumb {
          -webkit-appearance: none;
          height: 18px;
          width: 18px;
          border-radius: 50%;
          background: #4646fa;
          cursor: pointer;
          margin-top: -6px;
          box-shadow: 0 0 0 4px #fff, 0 0 0 5px #eee;
        }
        input[type=range]::-webkit-slider-runnable-track {
          height: 6px;
          border-radius: 5px;
          background: transparent;
        }
      `}</style>

    </div>
  );
}

export default EMICalculator;